import clsx from 'clsx';

import Button from '@/componentsv2/Button';

interface ResendCodeProps {
  /** From `useResendCountdown`. */
  secondsLeft: number;
  onResend: () => void;
  /** A request is in flight. */
  disabled?: boolean;
  className?: string;
}

/**
 * "Resend code in 30s", then "Resend code" once the wait is over (ENG-6323).
 * One button throughout, held with `aria-disabled` rather than `disabled`, so
 * a keyboard user who sent a code keeps focus on it while it counts again.
 */
export function ResendCode({
  secondsLeft,
  onResend,
  disabled = false,
  className,
}: ResendCodeProps): JSX.Element {
  const counting = secondsLeft > 0;
  const held = counting || disabled;
  return (
    <Button
      type="button"
      variant="tertiary"
      aria-disabled={held}
      onClick={held ? undefined : onResend}
      className={clsx(
        'min-h-48',
        // Tertiary teal is 3.5:1 on the dark surface: brand-primary there.
        held
          ? '!cursor-default !bg-transparent !text-on-surface-secondary'
          : 'dark:!text-brand-primary',
        className
      )}
    >
      {counting ? `Resend code in ${secondsLeft}s` : 'Resend code'}
    </Button>
  );
}
